export function LiveEngagementsIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='22' height='20' viewBox='0 0 22 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M21 10H17L14 19L8 1L5 10H1'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
